(function () {
  // Classes générées par l'app (suffixe variable) : on cible leur début.
  const WIDGET_SELECTOR = '[class^="cartInfoPrices_priceContainer_"]';
  const FINAL_SELECTOR = '[class^="cartInfoPrices_finalPrice_"]';
  const TOTAL_SELECTOR = '[class^="cartInfoPrices_total_"]';

  const ROOT_SELECTOR = '[data-fast-bundle-price]';

  const SALE_CLASSES = 'h6 text-on-sale';
  const REGULAR_CLASSES = 'h6';
  const COMPARE_CLASSES = 'h7 line-through';

  let originalHTML = null;

  function getPriceList() {
    return document.querySelector(`${ROOT_SELECTOR} price-list`);
  }

  // « €1.299,99 », « 1 299,99 € » ou « £1,299.99 » → centimes. Le dernier
  // séparateur suivi de deux chiffres est le séparateur décimal.
  function parseCents(text) {
    const cleaned = (text || '').replace(/[^\d.,]/g, '');
    const match = cleaned.match(/^(.*)[.,](\d{2})$/);
    const units = (match ? match[1] : cleaned).replace(/[.,]/g, '');
    const decimals = match ? match[2] : '00';
    return parseInt(units + decimals, 10) || 0;
  }

  // Format de la boutique exposé par snippets/js-variables.liquid, avec ou
  // sans code devise selon le réglage du thème, comme le filtre Liquid money.
  function formatMoney(cents) {
    const settings = window.themeVariables.settings;
    const format = settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat;

    const withDelimiters = (precision, thousands, decimal) => {
      const [whole, fraction] = (cents / 100).toFixed(precision).split('.');
      const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return fraction ? grouped + decimal + fraction : grouped;
    };

    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, placeholder) => {
      switch (placeholder) {
        case 'amount_no_decimals': return withDelimiters(0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(2, "'", '.');
        case 'amount_with_space_separator': return withDelimiters(2, ' ', ',');
        default: return withDelimiters(2, ',', '.');
      }
    });
  }

  // Remplace le montant en gardant le libellé sr-only du thème.
  function setAmount(element, cents) {
    const label = element.querySelector('.sr-only');
    element.textContent = formatMoney(cents);
    if (label) element.prepend(label);
  }

  function render(finalCents, totalCents) {
    const priceList = getPriceList();
    if (!priceList) return;

    const salePrice = priceList.querySelector('sale-price');
    if (!salePrice) return;

    const isOnSale = totalCents > finalCents;
    let comparePrice = priceList.querySelector('compare-at-price');

    salePrice.className = isOnSale ? SALE_CLASSES : REGULAR_CLASSES;
    setAmount(salePrice, finalCents);

    if (isOnSale) {
      if (!comparePrice) {
        comparePrice = document.createElement('compare-at-price');
        comparePrice.className = COMPARE_CLASSES;

        const label = document.createElement('span');
        label.className = 'sr-only';
        label.textContent = priceList.closest(ROOT_SELECTOR).dataset.compareLabel;
        comparePrice.append(label);

        salePrice.after(comparePrice);
      }
      setAmount(comparePrice, totalCents);
    } else if (comparePrice) {
      comparePrice.remove();
    }
  }

  function restore() {
    const priceList = getPriceList();
    if (priceList && originalHTML !== null) priceList.innerHTML = originalHTML;
  }

  function sync(widget) {
    const finalCents = parseCents(widget.querySelector(FINAL_SELECTOR)?.textContent);
    const totalCents = parseCents(widget.querySelector(TOTAL_SELECTOR)?.textContent);

    // Aucun article ajouté : le widget affiche 0, on remet le prix de la fiche.
    if (finalCents <= 0) {
      restore();
      return;
    }

    render(finalCents, Math.max(totalCents, finalCents));
  }

  function watch(widget) {
    const priceList = getPriceList();
    if (!priceList) return;

    originalHTML = priceList.innerHTML;
    sync(widget);

    new MutationObserver(() => sync(widget)).observe(widget, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  // Le widget est injecté par l'app après le chargement : on attend qu'il
  // apparaisse, puis on cesse d'observer la page.
  function init() {
    const widget = document.querySelector(WIDGET_SELECTOR);
    if (widget) {
      watch(widget);
      return;
    }

    const pageObserver = new MutationObserver(() => {
      const found = document.querySelector(WIDGET_SELECTOR);
      if (!found) return;
      pageObserver.disconnect();
      watch(found);
    });
    pageObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
